var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d-flex flex-row justify-content-center",
      attrs: { id: "PlanSelectionCompleted" },
    },
    [
      _c("a-card", { staticClass: "completed-card" }, [
        _c("div", { staticClass: "card-header-part" }, [
          _c("div", { staticClass: "card-header-part-header" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "blured-background-icon" },
            [
              _c("SupsisIcon", {
                staticClass: "styled-supsis-icon",
                attrs: { width: "180", height: "200" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "triangle" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "centered-icon" },
            [_c("SupsisIcon", { attrs: { width: "90", height: "90" } })],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "card-information-part",
            staticStyle: { height: "260px" },
          },
          [
            _c("div", { staticClass: "mx-2 my-0" }, [
              _c("h2", { staticClass: "my-0 px-5" }, [
                _vm._v("Bilgileriniz başarıyla kaydedildi"),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "description" }, [
                _vm._v(
                  "\n                    Sayın kullanıcı , yeni özellikleriniz aktif edildi. SUPSIS ayrıcalıklarını kullanmaya\n                    başlayabilirsiniz.\n                "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "a-button",
              {
                staticClass: "w-75 start-use-btn py-4",
                on: { click: _vm.buttonClickHandler },
              },
              [_vm._v(" Kullanmaya Başla")]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }